var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "menu_component",
      class: [_vm.collapsed ? "width80" : "width180"],
    },
    [
      _vm._m(0),
      _vm._m(1),
      _c(
        "a-menu",
        {
          staticStyle: { width: "100%" },
          attrs: {
            "default-selected-keys": _vm.selectedKeys,
            "open-keys": _vm.openKeys,
            mode: "inline",
            "inline-collapsed": _vm.collapsed,
            theme: "light",
          },
          on: { openChange: _vm.onOpenChange },
        },
        [
          _vm._l(_vm.menuList, function (menu) {
            return [
              !menu.children
                ? _c(
                    "a-menu-item",
                    {
                      key: menu.path,
                      on: {
                        click: function ($event) {
                          return _vm.onClickItem(menu)
                        },
                      },
                    },
                    [
                      _c("icon-font", { attrs: { type: menu.icon } }),
                      _c("span", [_vm._v(_vm._s(menu.title))]),
                    ],
                    1
                  )
                : _c(
                    "a-sub-menu",
                    { key: menu.path },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "title" }, slot: "title" },
                        [
                          _c("icon-font", { attrs: { type: menu.icon } }),
                          _c("span", [_vm._v(_vm._s(menu.title))]),
                        ],
                        1
                      ),
                      _vm._l(menu.children, function (subMenu) {
                        return _c(
                          "a-menu-item",
                          {
                            key: subMenu.path,
                            on: {
                              click: function ($event) {
                                return _vm.onClickItem(subMenu)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(subMenu.title) + " ")]
                        )
                      }),
                    ],
                    2
                  ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: {
          src: "http://usdb.oss-us-west-1.aliyuncs.com/web_images/firmware-update/NEEWER@2x.png",
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo2" }, [
      _c("img", {
        attrs: {
          src: "http://usdb.oss-us-west-1.aliyuncs.com/web_images/firmware-update/NEEWER@2x.png",
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }